import React, { useState } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";
import fire from "../../config/Fire";

function CreateAgent() {
  const [formData, setFormData] = useState({
    agentFirstName: "",
    agentLastName: "",
    agentEmail: "",
    agentTelephone: "",
    agentPassword: ""
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const signup = (e) => {
    e.preventDefault();
    fire
      .auth()
      .createUserWithEmailAndPassword(formData.agentEmail, formData.agentPassword)
      .then((data) => {
        console.log("Successfully created user");
        console.log(data);

        API.saveAgent({
          uid: data.user.uid,
          firstName: formData.agentFirstName,
          lastName: formData.agentLastName,
          email: data.user.email,
          telephone: formData.agentTelephone,
          servicer: formData.clientServicer
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <div
        className="card"
        style={{
          boxShadow: "0px 0px 4px 4px black",
          borderRadius: "10px",
          color: "black",
          overflow: "auto",
          padding: "0"
        }}
      >
        <div className="row">
          <div className="col">
            <div className="card-body">
              <h3 style={{ textAlign: "center" }}> Create Agent </h3>
              <form>
                <Table bordered hover style={{ backgroundColor: "white" }}>
                  <tbody>
                    <tr>
                      <th>Question</th>
                      <th>Input</th>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          backgroundColor: "black",
                          color: "white",
                          fontWeight: "bold"
                        }}
                      >
                        First name
                      </td>
                      <td>
                        <input
                          type="text"
                          value={formData.agentFirstName}
                          onChange={handleInputChange}
                          name="agentFirstName"
                          placeholder="First Name"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          backgroundColor: "black",
                          color: "white",
                          fontWeight: "bold"
                        }}
                      >
                        Last name
                      </td>
                      <td>
                        <input
                          type="text"
                          value={formData.agentLastName}
                          onChange={handleInputChange}
                          name="agentLastName"
                          placeholder="Last Name"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          backgroundColor: "black",
                          color: "white",
                          fontWeight: "bold"
                        }}
                      >
                        Email
                      </td>
                      <td>
                        {" "}
                        <input
                          type="text"
                          value={formData.agentEmail}
                          onChange={handleInputChange}
                          name="agentEmail"
                          placeholder="E-mail address"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          backgroundColor: "black",
                          color: "white",
                          fontWeight: "bold"
                        }}
                      >
                        Password
                      </td>
                      <td>
                        <input
                          type="text"
                          value={formData.agentPassword}
                          onChange={handleInputChange}
                          name="agentPassword"
                          placeholder="Password"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          backgroundColor: "black",
                          color: "white",
                          fontWeight: "bold"
                        }}
                      >
                        Telephone
                      </td>
                      <td>
                        <input
                          type="text"
                          value={formData.agentTelephone}
                          onChange={handleInputChange}
                          name="agentTelephone"
                          placeholder="Telephone number"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <button
                          style={{
                            color: "white",
                            fontSize: "20px",
                            boxShadow: "0px 0px 1px 1px black",
                            backgroundImage: "linear-gradient(147deg, black 90%, white 0%)",
                            padding: "5px 20px 5px 20px",
                            borderRadius: "5px"
                          }}
                          onClick={(e) => signup(e)}
                        >
                          Submit
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateAgent;
